import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppDispatch } from "../../../../shared/model";
import { setChatOpen } from "../../../../entities/settings/model";
import { removeMessageQuery } from "../../../../shared/lib";
import { useInitialSubmit } from "../useInitialSubmit";
var IS_CHAT_OPEN_QUERY = 'is_chat_open';
var INITIAL_MESSAGE_QUERY = 'initial_message';
var getSettings = function getSettings(params) {
  // Дефолтные настройки при использовании квери параметров (возможно будет много)
  var defaultSettings = {
    isChatOpen: true,
    initialMessage: true
  };
  if (typeof params === 'boolean') {
    if (!params) {
      return {};
    }
    return defaultSettings;
  }
  return _objectSpread(_objectSpread({}, defaultSettings), params);
};
var getIsActive = function getIsActive(params, key) {
  return (typeof params === 'boolean' ? params : getSettings(params)[key]) === true;
};
var queryStringToObject = function queryStringToObject() {
  var obj = {};
  new URLSearchParams(window.location.search).forEach(function (value, key) {
    obj[key] = value;
  });
  return obj;
};
var useChangeUrl = function useChangeUrl(isActive) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    queries = _useState2[0],
    setQueries = _useState2[1];
  var onChange = useCallback(function () {
    setQueries(queryStringToObject());
  }, []);
  useEffect(function () {
    if (isActive && window) {
      onChange();
      // Листенер для отслеживания перемещения пользователя по истории
      window.addEventListener('popstate', onChange);

      // eslint-disable-next-line @typescript-eslint/unbound-method
      var pushState = window.history.pushState;

      // Меняем метод для того чтоб мы могли считывать изменный url после вызова методов react-router-dom
      window.history.pushState = function () {
        onChange();
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return pushState.call.apply(pushState, [window.history].concat(args));
      };
    }
    return function () {
      var _window;
      (_window = window) === null || _window === void 0 || _window.removeEventListener('popstate', onChange);
    };
  }, [isActive]);
  return useMemo(function () {
    return {
      queries: queries
    };
  }, [queries]);
};
export var useChatOpenQuery = function useChatOpenQuery(params) {
  var isActive = getIsActive(params, 'isChatOpen');
  var settings = getSettings(params);
  var dispatch = useAppDispatch();
  var _useChangeUrl = useChangeUrl(isActive),
    queries = _useChangeUrl.queries;
  useEffect(function () {
    if (queries[IS_CHAT_OPEN_QUERY] && settings.isChatOpen && isActive) {
      dispatch(setChatOpen(queries[IS_CHAT_OPEN_QUERY] === 'true'));
    }
  }, [isActive, JSON.stringify(queries), JSON.stringify(settings)]);
};
export var useInitialMessageQuery = function useInitialMessageQuery(params) {
  var isActive = getIsActive(params, 'initialMessage');
  var settings = getSettings(params);
  var _useChangeUrl2 = useChangeUrl(isActive),
    queries = _useChangeUrl2.queries;
  var submit = useInitialSubmit();
  useEffect(function () {
    if (queries[INITIAL_MESSAGE_QUERY] && settings.initialMessage && isActive) {
      submit(queries[INITIAL_MESSAGE_QUERY]);
      removeMessageQuery(INITIAL_MESSAGE_QUERY);
    }
  }, [isActive, JSON.stringify(queries), JSON.stringify(settings)]);
};